export const ATP_BANNER_LIMIT_KEY = 'canShowATPBanner';
export const CARD_APPLY_BANNER_LIMIT_KEY = 'canCardApplyBannerShow';
export const FALSE = 'false';
export const TRUE = 'true';



// WEBPACK FOOTER //
// ./src/constants/session-constants.js